export enum StorageKey {
	NAV_TO = 'navTo',
	FILTER_QUERY = 'filterQuery',
	QUEUE_QUERY = 'queueQuery',
	BLOCK_DATE = 'blockDate',
	BLOCK_SURGEONS = 'blockSurgeons',
	SCHEDULE_FACILITY = 'scheduleFacility',
	LOGIN_SESSION_ID = 'loginSessionId',
}
